<template>
  <div class="rect">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-if="data" class="comRect">
      <van-image
        width="4em"
        height="4em"
        :src="data.commodityIcon?data.commodityIcon:'/img/defaultcom.jpg'"
      />
      <div class="comTitle">
        {{ data.commodityName }}
      </div>
      <div class="buttonBuy" @click="onBack">
        <i class="iconfont icongouwuche" :style="'color: '+GetColorMain()" />
      </div>
    </div>
    <div class="questionRect">
      <van-row>
        <van-col span="2">
          <van-image
            width="2em"
            height="2em"
            round
            fit="cover"
            :src="data.asker.userIcon?data.asker.userIcon:'/img/defaultIcon.jpg'"
          />
        </van-col>
        <van-col span="22">
          <div class="questionBody">
            <span class="user">{{ data.asker.userName }}</span>
            <div class="date">{{ formatDate( data.asker.createTime,"yyyy年MM月dd日",false) }}</div>
            <div class="body">
              <i class="iconfont iconwen" /> {{ data.asker.body }}
            </div>
          </div>
        </van-col>
      </van-row>
    </div>

    <div class="answerTitle">
      <van-row>
        <van-col span="12"><i class="iconfont iconda" /> 共{{ data.totalAnswer }}条回答</van-col>
        <van-col span="12" class="rigth"><van-button v-show="showAnswerButton" plain type="primary" size="small" :color="GetColorMain()" @click="onAnswerAdd">回答咨询</van-button></van-col>
      </van-row>

    </div>
    <div v-if="data" class="answerRectList">
      <div v-for="item in data.answers" :key="item.id" class="answerRect">
        <van-row>
          <van-col span="2">
            <van-image
              width="2em"
              height="2em"
              round
              fit="cover"
              :src="item.userIcon?item.userIcon:'/img/defaultIcon.jpg'"
            />
          </van-col>
          <van-col span="22">
            <div class="questionBody">
              <span class="user">{{ item.userName }} </span><van-tag v-if="item.userRole" type="danger">{{ item.userRole }}</van-tag>
              <div class="date">{{ formatDate( item.createTime,"yyyy年MM月dd日",false) }}</div>
              <div class="body" v-html="item.body" />
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>

</template>
<script>
import request from '@/utils/request'
import { Button, Notify, Image, Tag } from 'vant'
import TopBar from '@/components/TopBar'
import { formatDate, getUserBase } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Notify.name]: Notify,
    [Image.name]: Image,
    [Tag.name]: Tag,
    TopBar
  },
  data() {
    return {
      title: '商品咨询',
      backurl: '/store/index/',
      id: undefined,
      showAnswerButton: false,
      data: {
        asker: {},
        answers: []
      }
    }
  },
  created() {
    this.id = this.$route.params.id
    this.onInit()
    getUserBase(data => {
      if (!data) {
        return
      }
      if (data.proAccountId) {
        this.showAnswerButton = true
      } else {
        this.showAnswerButton = false
      }
      console.log('用户数据', data)
    })
  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    formatDate,
    onInit() {
      request({
        url: '/Store/getShopCommodityQA',
        method: 'post',
        params: { id: this.id }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.backurl = '/store/item/' + this.data.commodityId
      })
    },
    onAnswerAdd() {
      this.$router.push('/store/questionAnswer/' + this.id + '?commodity=' + this.data.commodityId)
    },
    onBack() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push(this.backurl)
    }
  }
}
</script>
<style scoped>
.rect
{
  height: 100vh;
  position: relative;
}
.comRect {
  position: relative;
  background-color: #fff;
  padding: 0.5em;
  border-bottom: 1px solid #f5f5f5;
}
.comRect .comTitle{
  position: absolute;
  left: 5em;
  line-height: 3em;
  top:0.5em;
  right: 3.5em;
  overflow:hidden; /*超出的部分隐藏起来。*/
  white-space:nowrap;/*不显示的地方用省略号...代替*/
  text-overflow:ellipsis;/* 支持 IE */
}
.comRect .buttonBuy{
  position: absolute;
  right: 0.5em;
  top: 1em;
  height: 2em;
  width: 2em;
  line-height: 2em;
  text-align: center;
  border-radius: 2em;
  font-weight: 700;
  background-color: #eee;
}
.questionRect{
  background-color: #fff;
  position: relative;
  padding: 1em 1em;
}
 .questionBody{
  padding-left: 0.5em;
}
 .questionBody .user
{
  font-weight: 700;
}
 .questionBody .date{
  font-size: 0.8em;
  color: #999;
   line-height: 1.8em;
}
 .body{
  padding: 0.5em 0 0 0.5em;
}
.answerTitle{
  margin-top: 0.5em;
  background-color: #fff;
  padding:0.5em;
}
.answerRectList{
  background-color: #fff;
  padding: 0.5em 0.5em 1em 0.5em;
}
.answerRect{
  box-shadow: 3px 3px 10px #eaeaea;
  background-color: #fff;
  position: relative;
  padding: 0.5em;
  margin-bottom: 0.5em;
}
</style>
